import PrepTaskModel from "@/models/lab/PrepTaskModel";
import LabServiceCollection from "@/collections/LabServiceCollection";


export default class PrepTaskCollection extends LabServiceCollection {
  model() {
    return PrepTaskModel;
  }

  prepareFilter(CollectionFilter) {
    CollectionFilter.defaultSortAddAsc('order');
  }

}
